module.exports = __webpack_public_path__ + "img/zb2.a3f8835d.png";